import { memo, useEffect, useState } from "react";
import CommonBtn from "../../../../app/common-components/ui-components/Button/Index.jsx";
// import CompleteTableBtn from "../../../common/Table/CompleteTableBtn.js";
import { get } from "lodash";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomModal from "../../../../app/common-components/CustomModal";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from '../../../../app/common-components/Table/CompleteTableData.jsx';
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import "../styles.scss";
import AddAssetConfig from "./AddAssetConfig.js";
import { deleteAsset, getById, getList, saveAsset } from "./AssetSlice.js";



const AssetConfiguration = () => {
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const dispatch = useDispatch();
  const { common } = useSelector((state) => state);
  let { getCmdbId } = useSelector((state) => state.cmdbId);
  const { dataAsset, saveLoading, deleteData, tableList,tableLoading, deleteLoading, countAssect, CALoading } = useSelector(
    (state) => state.assetApi
  );
  
  console.log("tableList", tableList);
  const pageNo = get(common, "completeTable.pageNo", []);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState("");

  const [listPayload, setlistPayload] = useState({});

  const fetchData = (PageNo = currentPageNo, Limit = pageLimit, key = searchInputValue) => {

    const Payload = {
      pageNumber: PageNo,
      itemsPerPage: Limit,
      payload: { cmdbId: getCmdbId, keyword: key, deviceName: [] },
    };
    setlistPayload(Payload);
    dispatch(getList(Payload));
  };
  const [state, setState] = useState({
    modalOpen: false,
    deleteModal: false,
    deletepayload: {},
    callFrom: "add",
  });
  // const hideAlert = () => {
  //   dispatch(resetData());
  // };

  useEffect(() => {
    setCurrentPageNo(0);
    setSearchInputValue("");
    fetchData(0, 10, "");
    console.log("happen useeef");
  }, []);
  const callAlert = (message) => {
    callCommonAlert("success", message);
    hideCommonAlert();
  };
  const handleShow = (props) => {
    setState({
      ...state,
      modalOpen: true,
      callFrom: props,
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
  };
  const deletehandleShow = (props) => {
    setState({
      ...state,
      deleteModal: true,
      deletepayload: props,
    });
  };
  const deletehandleClose = () => {
    setState({
      ...state,
      deleteModal: false,
      deletepayload: {},
    });
  };
  const saveAPICall = (payload) => {
    dispatch(saveAsset(payload)).then((response) => {
    console.log("response:", response);

    const res = response?.payload ?? {};

    const statusCodeValue = 
      typeof res.statusCodeValue === "number"
        ? res.statusCodeValue
        : null;

    const body = 
      typeof res.body === "string"
        ? res.body
        : "Operation completed";

    const SUCCESS_CODES = [200, 201, 202, 204];

    if (SUCCESS_CODES.includes(statusCodeValue)) {
      callCommonAlert("success", body);

      // setTimeout(() => {
      //   dispatch(resetData());
      // }, 1000);

      setState((prev) => ({
        ...prev,
        modalOpen: false,
      }));

      setCurrentPageNo(0);
      setPageLimit(10);
      setSearchInputValue("");
      fetchData(0, 10, "");
    } else {
      callCommonAlert("error", body || "Operation failed");
    }
  })
.catch((error) => {
      console.error("Delete asset error:", error);
      callCommonAlert("error", "Network error occurred");
    }).finally(() => {
      hideCommonAlert(); // Ensure alert is always hidden
    });
  };
  const deleteModalBody = () => {
    return (
      <>
        <h4 className="delete-h"> Delete Asset Configuration</h4>
        {deleteLoading ? <Spinners /> : (
          <div>
            <p>Deleting this configuration will affect the TRS score of the asset. Are you sure you would like to delete the Asset Configuration?</p>
            <div className="btnswrap btn-dlt">
              {/* <a
            type="submit"
            className="cancelBtnStyle btn btn-primary"
            onClick={deletehandleClose}
          >
            Cancel
          </a> */}
              <ButtonComponent
                className={"cancelBtnStyle btn btn-primary"}
                data-testid="cancelBtn"
                onClick={deletehandleClose}
                text="Cancel"
              />
              <ButtonComponent
                text="Delete"
                className={"btnStyle btn btn-primary"}
                data-testid="deleteConfirmBtn"
                onClick={() => {
                  deleteId(state.deletepayload);
                  deletehandleClose();
                }}
              />
            </div>
          </div>)}
      </>
    );
  };
  const deleteId = (deletepayload) => {
    dispatch(deleteAsset(deletepayload)).then((resp) => {
      console.log('resp: ', resp);
      const { statusCodeValue, body } = resp?.payload || {};
      console.log('body: ', body);

      if (statusCodeValue === 200) {
        callCommonAlert("success", body);

        // setTimeout(() => {
        //   dispatch(resetData());
        // }, 1000);
      } else {
        callCommonAlert("error", body || "Deletion failed");
      }
    }).catch((error) => {
      console.error("Delete asset error:", error);
      callCommonAlert("error", "Network error occurred");
    }).finally(() => {
      hideCommonAlert(); // Ensure alert is always hidden
    });
  };
  const dataheader = [
    {
      Header: "Sl.No",
      className: "text-center noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "curser",
      isTooltip: "Serial number",
      Cell: ({ row }) => {
        const serialNumber = row.index + 1;
        return <>{serialNumber}</>;
      },
    },
    {
      Header: "Device Name",
      accessor: "deviceName",
      className: "text-start noSort",
      thClassName: "curser",
      disableSortBy: true,
      isTooltip: "Device Name",
    },
    {
      Header: "Environment",
      accessor: "environment",
      className: "text-start noSort",
      thClassName: "curser",
      disableSortBy: true,
      isTooltip: "Environment",
    },
    {
      Header: "Risk Score Metrics",
      colSpan: 4,
      className: "text-center noSort",
      thClassName: "text-center",
      disableSortBy: true,
      columns: [
        {
          Header: "Exposure",
          accessor: "exposure",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates asset network location & Internet Proximity",
        },
        {
          Header: "Protection",
          accessor: "protectionMeasure",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates protection measures implemented to enhance the asset's defense against vulnerability exploitation",
        },
        {
          Header: "Detection",
          accessor: "detectionMeasure",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates security measures implemented to identify and counteract vulnerability exploitation in the asset.",
        },
        {
          Header: "Distribution",
          accessor: "distribution",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates the extend and reach of the attack surface associated with this asset.",
        },
      ],
    },
    {
      Header: "Environment Metrics",
      colSpan: 3,
      className: "text-center noSort",
      thClassName: "text-center",
      disableSortBy: true,
      columns: [
        {
          Header: "Confidentiality",
          accessor: "confidentialityRequirement",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates the importance of data confidentiality. Each level reflects the potential adverse effect on your organization in case of a confidentiality breach.",
        },
        {
          Header: "Integrity",
          accessor: "integrityRequirement",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates the criticality of data integrity. Each level reflects the potential impact of integrity loss on your organization.",
        },
        {
          Header: "Availability",
          accessor: "availabilityRequirement",
          className: "text-start noSort",
          thClassName: "curser",
          disableSortBy: true,
          isTooltip: "Indicates the significance of asset availability. Each level reflects the potential adverse impact on your organization due to a availability loss.",
        },
      ],
    },
    {
      Header: "Actions",
      className: "text-center noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "curser text-center",
      isTooltip: "To modify or delete",
      Cell: ({ row }) => {
        return (
          <div className="d-flex justify-content-center">
            <div className="actcol">
              <a
                title="Edit"
                onClick={() => {
                  dispatch(getById(row.original.id)), handleShow('edit');
                }}
              >
                <FiEdit className="iconStyleActions" />
              </a>
            </div>
            <div className="actcol">
              <a
                title="Delete"
                onClick={() => {
                  deletehandleShow({ id: row.original.id, cmdbId: getCmdbId, listPayload });
                }}
              >
                <FiTrash2 className="iconStyleActions" data-testid="deleteIcon" />
              </a>
            </div>
          </div>
        );
      },
    },
  ];
  const toggleClassName = () => {
    console.log("called");
  };
  const btnData = [
    {
      text: "Add",
      btnComponent: (
        <>
          <CommonBtn
            name="Add"
            clickFunc={() => handleShow('add')}
            btnStyle="icon-btn"
          //icon={<FaPlus className="cmdbImgIcon mx-1" />}
          />
        </>
      ),
    },
  ];
  const handlePageLimitChange = (newPageLimit) => {
    console.log(newPageLimit);
    setPageLimit(newPageLimit);
    setCurrentPageNo(0);
    fetchData(0, newPageLimit, searchInputValue);

  };
  const handlePageNoChange = (pageNumber) => {
    console.log(pageNumber);
    if (pageNumber === 0) {
      setCurrentPageNo(0);
      fetchData(0, pageLimit, searchInputValue);
    } else {
      setCurrentPageNo(pageNumber);
      fetchData(pageNumber, pageLimit, searchInputValue);

    }
  };
  const onSearch = (e) => {
    console.log(e);
    setCurrentPageNo(0);
    setSearchInputValue(e);
    fetchData(0, pageLimit, e);
  };
  const modalBody = () => (
    <>
      <AddAssetConfig handleClose={handleClose} saveAPICall={saveAPICall} open={state.modalOpen} callFrom={state.callFrom} reloadPayload={listPayload} />
    </>
  );
  const calculatedPageCount =
    tableList ? Math.ceil(tableList.totalCount / pageLimit) : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
  
  return (
    <>
      <div className="dashcol bg-white mt-3">
        <h4>Asset Configuration</h4>
        {/* <TRSMetrics/> */}
        {/* {saveLoading || tableLoading || deleteLoading || CALoading ? (
          <Spinners/>
        ):(
        <CompleteTableBtn
          data={tableList}
          columns={dataheader}
          tableClass="Gray_table"
          isPagenation={true}
          isSearch={true}
          btnData={btnData}
        /> */}
        <CompleteTableData
          isLoading={tableLoading}
          data={tableList.data ? tableList.data : []}
          columns={dataheader}
          marginUp={true}
          rowCondt={true}
          pageNo={pageNo}
          pageLimit={pageLimit}
          onPageLimitChange={handlePageLimitChange}
          listCount={tableList.totalCount}
          onPageNoChange={handlePageNoChange}
          curentPageNumber={currentPageNo}
          totalPageCount={finalPageCount}
          onSearch={onSearch}
          searchKey={searchInputValue}
          btnData={btnData}
          moveSearchToEnd={true}
        />
        {/* )} */}
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          closeBtn={true}
          closeBtnFuc={handleClose}
          size={"lg"}
        />
        <CustomModal
          modalOpen={state.deleteModal}
          modalBody={deleteModalBody}
          closeBtn={true}
          closeBtnFuc={deletehandleClose}
        />
      </div>
    </>
  );
};
export default memo(AssetConfiguration);

